import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useLocale } from '@merchant-portal/merchant-portal-base'
import ForgotUI from './ForgotUI'
import {
  forgotPassword,
  passwordResetStatus,
} from '../../../store/actions/password-actions'

const Forgot = ({ reset, passwordReset, forgot }) => {
  const { language } = useLocale()[0]
  useEffect(() => reset(), [])

  return (
    <ForgotUI
      reset={passwordReset}
      onReset={email => forgot(email, language)}
    />
  )
}

Forgot.propTypes = {
  forgot: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  passwordReset: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  passwordReset: state.password.reset,
})

const mapDispatchToProps = dispatch => ({
  reset: () => {
    dispatch(passwordResetStatus())
  },
  forgot: (email, language) => {
    dispatch(forgotPassword(email, language))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Forgot)
